"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jquery_1 = __importDefault(require("jquery"));
class Login {
    constructor() {
        (0, jquery_1.default)("#modal-login").on("submit", function (e) {
            e.preventDefault();
            const $message = (0, jquery_1.default)("#login-message");
            // フォームデータの取得
            const formData = new FormData();
            formData.append("action", "ajaxlogin");
            const username = (0, jquery_1.default)("#username").val();
            formData.append("username", typeof username === "string" ? username : "");
            const password = (0, jquery_1.default)("#password").val();
            formData.append("password", typeof password === "string" ? password : "");
            const remember = (0, jquery_1.default)("#remember").is(":checked");
            formData.append("remember", remember ? "true" : "false");
            const security = (0, jquery_1.default)("#security").val();
            formData.append("security", typeof security === "string" ? security : "");
            // @ts-ignore
            fetch(ajax_login_object.ajaxurl, {
                method: "POST",
                body: formData,
                credentials: "same-origin",
            })
                .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
                .then((data) => {
                if (data.loggedin) {
                    // ログイン成功
                    //リロードする
                    location.reload();
                }
                else {
                    // ログイン失敗
                    $message.html('<div class="form__error">メールアドレス・またはパスワードが間違っています。</div>');
                }
            })
                .catch((error) => {
                console.error("Error:", error);
                $message.html('<div class="form__error">エラーが発生しました。後ほど再度お試しください。</div>');
            });
        });
    }
}
exports.default = Login;
new Login();
